// extracted by mini-css-extract-plugin
export default {"footerATag":"FooterMenuList_footerATag__7m3t9"};